import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order, Orders } from '../../../shared/classes/order';
import { OrderService } from '../../../shared/services/order.service';
import { ProductService } from '../../../shared/services/product.service';
import { HttpService } from '../../../services/http.service';
import { AuthService } from '../../../shared/services/auth.service';
import { FirestoreService } from '../../../services/firestore.service';
import { User } from '../../../shared/classes/user';
import { AppNotifications } from '../../../shared/classes/mail';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit, AfterViewInit {
    @ViewChild('content2') content2: TemplateRef<any>;
    public orderDetails = {
        shippingDetails: null,
        items: [],
        orderId: null,
        totalAmount: null,
        total: null,
        subtotal: 0,
        shipping_cost: 0,
        tax: 0,
        service_fee: 0,
        created_at_formatted: null,
        waytopay: null,
        used_credits: 0,
    };
    items: any[] = [];
    order = new Orders();
    isLogged: boolean = false;
    rawOrder: any[] = [];

    user = new User();
    txtSuccess: string = '<p>Se ha recibido el pago del Pedido con éxito</p><p>Transacción ID: $order_uid</p>';
    currency: any = this.productService.Currency;

    constructor(
        public productService: ProductService,
        private orderService: OrderService,
        private auth: AuthService,
        private service: HttpService,
        private firestoreService: FirestoreService,
        private route: ActivatedRoute
    ) {
        let txtSuccess = localStorage.getItem('txtSuccess') || '';
        if (txtSuccess != null || txtSuccess != undefined) {
            this.txtSuccess = txtSuccess;
        }
        this.auth.getUser2().then(async userLocal => {
            this.isLogged = true;
            this.user = userLocal;
            this.getOneOrder();
        }).catch(e => {
            console.error('Error getting user:', e);
        });
    }

    ngOnInit(): void {
        //console.log('this.orderDetails', this.orderDetails);
    }

    ngAfterViewInit() {

    }

    /**
     * Intenta obtener la orden primero desde el backend
     * Si falla, consulta directamente a Firestore
     */
    getOneOrder() {
        let order_uid = localStorage.getItem('order_uid');
        
        // Si no hay en localStorage, intentar obtener de la URL
        if (!order_uid || order_uid === '') {
            order_uid = this.route.snapshot.paramMap.get('id') || 
                        this.route.snapshot.params['id'] || 
                        this.getOrderUidFromUrl();
        }
        
        //console.log('order_uid a consultar:', order_uid);
        
        if (order_uid && order_uid != '') {
            if (localStorage.getItem('order_uid')) {
                localStorage.removeItem('order_uid');
            }
            this.productService.clearCart();

            // OPCIÓN 1: Intentar desde el backend
            this.getOrderFromBackend(order_uid);
        } else {
            console.error('No se encontró order_uid');
            Swal.fire('Error', 'No se pudo identificar la orden', 'error');
        }
    }

    /**
     * OPCIÓN 1: Obtener orden desde el backend
     * MANTIENE la validación del usuario
     */
    private getOrderFromBackend(order_uid: string) {
        //console.log('Intentando obtener orden desde backend...');
        
        this.service.getOneOrder(order_uid).subscribe({
            next: (res) => {
                if (res && res.user_uid == this.user.uid) {
                    //console.log('✓ Orden obtenida desde BACKEND');
                    this.processOrder(res);
                } else {
                    console.warn('Backend devolvió orden pero usuario no coincide');
                    this.getOrderFromFirestore(order_uid);
                }
            },
            error: (err) => {
                console.error('✗ Error obteniendo orden desde backend:', err);
                //console.log('Intentando fallback a Firestore...');
                this.getOrderFromFirestore(order_uid);
            }
        });
    }

    /**
     * OPCIÓN 2: Obtener orden directamente desde Firestore (fallback)
     * SIN validación de usuario, usa función especializada
     */
    private getOrderFromFirestore(order_uid: string) {
        //console.log('Obteniendo orden desde FIRESTORE...');
        //console.log('UID recibido:', order_uid);
        
        // Intentar obtener el UID desde la URL si no se proporcionó
        if (!order_uid || order_uid === '') {
            order_uid = this.route.snapshot.paramMap.get('id') || 
                        this.route.snapshot.params['id'] || 
                        this.getOrderUidFromUrl();
            //console.log('UID obtenido desde URL:', order_uid);
        }

        if (!order_uid || order_uid === '') {
            console.error('No se pudo obtener el UID de la orden');
            Swal.fire('Error', 'No se pudo identificar la orden', 'error');
            return;
        }
        
        //console.log('Consultando Firestore con UID:', order_uid);
        
        // Usar la función especializada para obtener la orden
        this.firestoreService.getOrderByUid(order_uid).subscribe({
            next: (res) => {
                //console.log('Respuesta de Firestore:', res);
                if (res) {
                    //console.log('✓ Orden obtenida desde FIRESTORE');
                    //console.log('Datos de la orden:', res);
                    
                    // Asegurar que tenga los campos necesarios
                    res.uid = res.uid || res.orderId || res.id || order_uid;
                    if (!res.id) res.id = res.uid;
                    
                    this.processOrder(res);
                } else {
                    console.error('Orden no encontrada en Firestore');
                    Swal.fire('Error', 'No se pudo encontrar la orden con ID: ' + order_uid, 'error');
                }
            },
            error: (err) => {
                console.error('✗ Error obteniendo orden desde Firestore:', err);
                Swal.fire('Error', 'No se pudo cargar la orden desde Firestore', 'error');
            }
        });
    }

    /**
     * Extrae el UID de la orden desde la URL
     * Ejemplo: http://localhost:4200/shop/checkout/success/HQN6KMQ5W -> HQN6KMQ5W
     */
    private getOrderUidFromUrl(): string {
        const url = window.location.pathname;
        const segments = url.split('/');
        // Asume que el UID está al final de la URL
        return segments[segments.length - 1] || '';
    }

    /**
     * Procesa la orden una vez obtenida (desde backend o Firestore)
     */
    private processOrder(res: any) {
        //console.log('📦 Procesando orden completa:', res);
        
        // Llenar los detalles de la orden
        this.orderDetails.orderId = res.uid || res.orderId;
        this.orderDetails.items = res.items || res.product || [];
        this.orderDetails.totalAmount = res.total || res.amount;
        this.orderDetails.total = res.total || res.amount;
        this.orderDetails.subtotal = res.subtotal || res.amount || 0;
        this.orderDetails.shipping_cost = res.shipping_cost || res.subtotalForRide || 0;
        this.orderDetails.tax = res.tax || 0;
        this.orderDetails.service_fee = res.service_fee || res.serviceFee || 0;
        this.orderDetails.used_credits = res.used_credits || 0;
        this.orderDetails.created_at_formatted = res.created_at_formatted || this.formatDate(res.order_createday);
        this.orderDetails.waytopay = res.waytopay || res.payment || 'Tarjeta';

        // Actualizar el estado de la orden
        let message = res;
        let finalStatusOrder = localStorage.getItem('finalStatusOrder');
        let finalBadgeColor = localStorage.getItem('finalBadgeColor');
        message.orders_status_uid = finalStatusOrder || 'New';
        message.badgeColor = finalBadgeColor || 'primary';

        this.service.updateOrder(message, message.id || message.uid).then(updateRes => {
            Swal.close();
            Swal.fire('Éxito', 'Pedido Procesado correctamente', 'success');
            console.info('update order', updateRes);
            
            // Limpiar localStorage
            localStorage.removeItem('mainBadgeColor');
            localStorage.removeItem('mainStatusOrder');
            localStorage.removeItem('finalStatusOrder');
            localStorage.removeItem('finalBadgeColor');
            localStorage.removeItem('txtSuccess');
        }).catch(err => {
            console.error('error update order', err);
        });

        // Enviar notificación por email
        this.sendOrderNotification(res);
    }

    /**
     * Formatea una fecha de Firestore timestamp
     */
    private formatDate(timestamp: any): string {
        if (!timestamp) return '';
        
        let date: Date;
        
        // Si es un Firestore Timestamp
        if (timestamp._seconds || timestamp.seconds) {
            const seconds = timestamp._seconds || timestamp.seconds;
            date = new Date(seconds * 1000);
        } 
        // Si ya es un objeto Date
        else if (timestamp.toDate) {
            date = timestamp.toDate();
        }
        // Si es un string o número
        else {
            date = new Date(timestamp);
        }
        
        const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const WEEKS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        
        return `${WEEKS[date.getDay()]}, ${date.getDate()} of ${MONTHS[date.getMonth()]} of ${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    }

    /**
     * Extrae la dirección en formato string
     */
    private getAddressString(direction: any): string {
        if (!direction) return '';
        
        // Si es un objeto con propiedad address
        if (typeof direction === 'object' && direction.address) {
            return direction.address;
        }
        
        // Si es un string
        if (typeof direction === 'string') {
            return direction;
        }
        
        // Si es un objeto con otras propiedades
        if (typeof direction === 'object') {
            // Intentar construir dirección de las propiedades disponibles
            const parts = [];
            if (direction.street) parts.push(direction.street);
            if (direction.city) parts.push(direction.city);
            if (direction.state) parts.push(direction.state);
            if (direction.country) parts.push(direction.country);
            return parts.join(', ');
        }
        
        return '';
    }

    /**
     * Envía las notificaciones por email
     */
    private sendOrderNotification(res: any) {
        // Extraer dirección correctamente
        const userAddress = this.getAddressString(res.direction) || 
                           this.getAddressString(res.place_delivery_user) || 
                           '';
        
        // Asegurar que los valores numéricos no sean NaN
        const subtotal = Number(res.subtotal || res.amount || 0);
        const tipAmount = Number(res.tip_amount || 0);
        const tax = Number(res.tax || 0);
        const delivery = Number(res.subtotalForRide || res.shipping_cost || 0);
        const total = Number(res.total || res.amount || 0);
        
        // //console.log('💰 Montos para email:', {
        //     subtotal,
        //     tipAmount,
        //     tax,
        //     delivery,
        //     total
        // });

        let mail: AppNotifications = {
            uid_mail_option: 'yRyi3kM7Lcv0CO8sjFRi',
            uid_notification_template: 'nVLciDaxW6aoblmrczyO',
            recipient: this.user.email,
            data: {
                uid_order: res.uid || res.orderId,
                commerce_name: res.sucursal || res.commerce_name || 'Tienda',
                commerce_direction: res.commerce_direction || '',
            }
        };

        let templateContent = localStorage.getItem('templateContent');
        let push2Options = {
            uid_mail_option: 'yRyi3kM7Lcv0CO8sjFRi',
            uid_notification_template: 'eavSm07EOrq39Cvhcfqn',
            recipient: this.user.email,
            data: {
                url_logo: res.commerce_image || '',
                contentItems: templateContent || '',
                subtotalInvoice: this.currency?.currency + ' ' + this.ToFixed(subtotal),
                tipInvoice: this.currency?.currency + ' ' + this.ToFixed(tipAmount),
                tax: this.currency?.currency + ' ' + this.ToFixed(tax),
                deliveryInvoice: this.currency?.currency + ' ' + this.ToFixed(delivery),
                totalInvoice: this.currency?.currency + ' ' + this.ToFixed(total),
                nameCustomer: res.who_receives || res.user_name || `${this.user.firstName} ${this.user.lastName}`,
                uid: res.uid || res.orderId,
                created_at_formatted: res.created_at_formatted || this.formatDate(res.order_createday),
                is_card: res.waytopay || res.payment || 'N/A',
                emailCustomer: this.user.email,
                addressCustomer: userAddress,
                commerce_direction: res.commerce_direction || '',
                commerce_name: res.sucursal || res.commerce_name || 'Tienda'
            }
        };

        //console.log('📧 Datos del email:', push2Options.data);

        this.service.sendEmail(push2Options).then((emailRes) => {
            //console.log('✅ Email enviado correctamente:', emailRes);
            localStorage.removeItem('templateContent');
        }).catch(err => {
            console.error('❌ Error enviando email:', err);
        });
    }

    ToFixed(data: number) {
        return Number(data).toFixed(2);
    }
}
